module.exports = __webpack_public_path__ + "img/microplastics-process-4-mobile.4bed4414.png";